module.exports = __webpack_public_path__ + "img/photo_2023-04-27 22.02.15.cff227d3.jpeg";